<template>
    <div class="section-heading mb-3">{{schema.label}}</div>
</template>

<script>



export default {

    data() {
        return {
        
        }
    },

    components: {
        
    },
    
    props: {
        value: String,
        schema: Object, 
    },

    computed: {

    },

    methods: {

    },

    created() {

    }
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// SectionHeadingControl.vue?c78a9cd2